import React from "react";

/**
 * «Фея Мотти» — помощница в правом нижнем углу.
 *
 * Максим 22.08.2026: кнопка должна выглядеть как игровой персонаж, на
 * которого нажимают за помощью, а не как значок в шапке. Значок в ряду
 * серых иконок никто не замечал: он ничем не отличался от переключателя
 * языка и темы.
 *
 * Угол выбран не случайно — там помощника ищут по привычке, выработанной
 * чатами поддержки, и он не спорит с меню.
 *
 * Рисунок пока векторный: настоящего арта Феи у меня нет, а ставить
 * случайную картинку хуже, чем нарисовать узнаваемый силуэт. Когда арт
 * появится, здесь меняется один тег.
 */

const FairySvg = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* Крылья */}
    <path
      d="M32 30c-6-9-14-13-19-10-4 3-2 11 4 15 4 3 10 3 15 1"
      fill="currentColor"
      opacity=".28"
    />
    <path
      d="M32 30c6-9 14-13 19-10 4 3 2 11-4 15-4 3-10 3-15 1"
      fill="currentColor"
      opacity=".28"
    />
    {/* Тело */}
    <path
      d="M32 24c3.2 0 5.6 2.2 5.6 5.2 0 2.4-1.3 4-2.6 5.4l-.6.7c1.9.9 3.4 2.3 4.4 4.2 1.3 2.5 1.6 5.4 1.6 8.5v3H23.6v-3c0-3.1.3-6 1.6-8.5 1-1.9 2.5-3.3 4.4-4.2l-.6-.7c-1.3-1.4-2.6-3-2.6-5.4 0-3 2.4-5.2 5.6-5.2z"
      fill="currentColor"
    />
    {/* Волшебная искра над головой */}
    <path
      d="M32 8l1.6 4.6L38 14l-4.4 1.4L32 20l-1.6-4.6L26 14l4.4-1.4L32 8z"
      fill="currentColor"
    />
    <circle cx="45" cy="19" r="2" fill="currentColor" opacity=".7" />
    <circle cx="20" cy="21" r="1.5" fill="currentColor" opacity=".55" />
  </svg>
);

const FairyButton = ({ onClick, hidden }) => {
  if (hidden) return null;

  return (
    <button
      type="button"
      className="fw-fairy"
      onClick={onClick}
      aria-label="Позвать Фею Мотти"
    >
      <span className="fw-fairy-pic">
        <FairySvg />
      </span>
      <span className="fw-fairy-name">Фея Мотти</span>
    </button>
  );
};

export default FairyButton;
